import { render, staticRenderFns } from "./YesterdayApp.vue?vue&type=template&id=77ece0aa&scoped=true"
import script from "./YesterdayApp.vue?vue&type=script&lang=js"
export * from "./YesterdayApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ece0aa",
  null
  
)

export default component.exports